import React from 'react'
import Stage11 from '../../images/Prize1dollar.svg'
import Stage12 from '../../images/Prize2dollar.svg'
import Stage13 from '../../images/Prize3dollar.svg'

const Romance_and_Paranormal_Romance = {
  template : 1,
  storyPoints: [
    {
      key: 1,
      point:
        'Stories with loved tropes and strong emotional arcs do well with our readers.',
    },
    {
      key: 2,
      point:
        'Keep us flipping the page by ending each chapter with a small cliffhanger so we have to know what happens next.',
    },
  ],
  StageContent: [
    {
      bgColor: '#F8F9FF',
      headingbgColor: '#D7DBF5',
      stageheading: 'Rules',
      stageSubHeading: 'The Contest starts May 16, 2022',
      tableContent: [
        {
          title: 'The last date to upload your book (min 80k words) ',
          img: '⌛',
          date: 'Aug 22, 2022',
        },
        {
          title: 'Results on ',
          img: '🎉',
          date: 'Aug 30, 2022',
        },
      ],
      stageContent: (
        <>
          Participants will be required to publish all the chapters of their
          book before the last day.
          <br />
          1. The book must be romance or paranormal romance and must have a
          happily ever after to qualify.
          <br />
          2. Books published between the start and end date will be considered
          qualified.
          <br />
          3. Each writer is only eligible for one prize.
          <br />
          4. Winning novels will be awarded the prize money post signing an
          exclusive IP contract with PocketNovels
        </>
      ),
      prizeHeading: 'Best book will be made to audiobook',
      firstPrize: Stage11,
      secondPrize: Stage12,
      thirdPrize: Stage13,
      rank4And5Prize: '$500/-',
      isLive: false,
    },
  ],
  exampleNovels: [
    {
      novelId: 'c1fdb835073c5adc3739dccdd0e58f94b88c7e75',
      title: 'Tamed By a BROKEN BEAST',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/6ff0542b02341e1b647d778c076a6de942cd4767.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/c1fdb835073c5adc3739dccdd0e58f94b88c7e75',
    },
    {
      novelId: '496e43b8e3cd37b967844d73d18264eb79a4375f',
      title: 'Love me like you do',
      novelImgLink:
        'https://djhonz7dexnot.cloudfront.net/e7f61dbbba6dc5ea735a1a668ccd13004effb428.jpeg',
      novelLink:
        'https://www.pocketnovel.com/novel/496e43b8e3cd37b967844d73d18264eb79a4375f',
    },
  ],
  FAQs: [
    {
      question: 'How to enter a book into the contest?',
      answer:
        'For books created after the contest start date; Go to the book & click on "Edit Novel " & select the contest & Save Changes.',
    },
    {
      question: 'When will the awards be given to the author?',
      answer:
        'The awards will be sent within thirty days after the results are announced.',
    },
  ],
  constants: {
    heading: 'Romance and Paranormal Romance',
    subHeading: 'Heartthrobs and heartbreak',
    bannerButton: 'JOIN THE CONTEST & WRITE',
    section_1_Heading: (
      <>
        The Contest is organized in the following way{' '}
        <span role="img"> 🏁 </span>:{' '}
      </>
    ),
    prizeSubheading:
      'The first prize will have the opportunity to possibly become an audiobook with a revenue share',
    stageButton: 'Enter Contest',
    section_2_Heading: 'Receive Certificate for your Literary Excellence',
    section_3_Heading: 'Sample Novels for Romance and Paranormal',
    novelContent: 'Read now',
    section_4_Heading: 'Writing Tips',
    earnHeading: 'Earn upto 10K dollars per year',
    earnSubheading: (
      <>
        After completion of 30K words you can enter into the <br />
        Writer’s Benefit Program
      </>
    ),
    earnSectionButton: 'Learn more about the program',
    section_5_Heading: 'Frequently Asked Questions ⁉️',
    contestId: 'f81df6ce7fb2a6d3df977109b66bf3af0cca9e7c',
    defaultReferrer: 'contest_romance_and_paranormal_romance',
    visibility: 'row',
    showCertifiicateImg: false,
    showCertificateLink: false,
  },
  participation_certificate_image:
    'https://djhonz7dexnot.cloudfront.net/827906bac4aed3a5ad4ee81eb03d27cb63982c2f.png',
  WinnersStage1: [
    {
      position: 1.1,
      AuthorName: 'Ajanaku Oluwafunmito Faith',
      NovelTitle: 'Married To The Mafia Lord',
      ImageUrl:
        'https://djhonz7dexnot.cloudfront.net/cd103a3a0ddb1884a0123394dd0c0fdd8c026cd1.jpeg',
      NovelUrl:
        'https://pocketnovel.com/novel/97ffbd4c9618987ace6211296f1425c3ed9e13ea',
      id: '97ffbd4c9618987ace6211296f1425c3ed9e13ea',
      Reward: '$3000',
    },
    {
      position: 1.2,
      AuthorName: 'Chalista Saqila',
      NovelTitle: 'THE BILLIONAIRE NEEDS BABY',
      ImageUrl:
        'https://djhonz7dexnot.cloudfront.net/0b946dc6da8ca1b5d5e6c5c1b0181b7620f207c3.jpeg',
      NovelUrl:
        'https://www.pocketnovel.com/novel/a0b5d4e531ecbbec132e9a98670d2c33569e448d',
      id: 'a0b5d4e531ecbbec132e9a98670d2c33569e448d',
      Reward: '$1500',
    },
    {
      position: 1.3,
      AuthorName: 'Author pink',
      NovelTitle: 'Bitten by the alpha',
      ImageUrl:
        'https://djhonz7dexnot.cloudfront.net/52a939b37154abdcbc1f139edf7dfdb0317f2748.jpeg',
      NovelUrl:
        'https://pocketnovel.com/novel/69f6dbb5caf0b8bedb3f3944ecdfa4a514a86bd1',
      id: '69f6dbb5caf0b8bedb3f3944ecdfa4a514a86bd1',
      Reward: '$1000',
    }
  ],

  WinnersStageText: {
    headingTitle: 'Announcing the results of our Romance and Paranormal Romance Contest!',
    subHeadingTitle: "We'd like to thank all the writers (nearly 160 of you!) who submitted an entry for this contest, the winners were chosen based on user approval ratings and all the winners submitted well over the minimum 80000 words we use to test!",
    topNovels: 'The Top 3 novels are...',
    paraTitle: 'Congratulations to our three winners! We will be in touch with you to get your contracts signed and the prize money transferred. We also have a few additional writers outside our Top 3 whose stories displayed great potential and we will be in touch with you as well!',
    subParaTitle: 'Thank you to everyone who participated and made this contest as exciting as it was! Keep writing and stay tuned to Pocket Novels for other such contests in the future!',
  }
}

export default Romance_and_Paranormal_Romance
